import React, { useState, useEffect } from 'react';
import PayPalButton from './PayPalButton'; 

const PaymentPage = ({ isDarkMode, onBack, planDetails, userId, onPaymentSuccess }) => {
  const [paymentError, setPaymentError] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState('paypal'); 

  const handlePayPalSuccess = (order) => {
    onPaymentSuccess(planDetails.id, order);
  };

  const handlePayPalError = (error) => {
    console.error('Error en PayPal:', error);
    setPaymentError('Ocurrió un error con PayPal. Por favor, inténtalo de nuevo o contacta a soporte.');
  };

  const mainBgClass = isDarkMode ? 'bg-gray-800 text-white' : 'bg-gray-50 text-gray-800';
  const cardBgClass = isDarkMode ? 'bg-gray-900' : 'bg-white';
  const titleColorClass = isDarkMode ? 'text-white' : 'text-gray-800';
  const priceColorClass = isDarkMode ? 'text-blue-400' : 'text-blue-600';
  const textColorClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const methodButtonSelectedClass = 'bg-blue-600 text-white shadow-md';
  const methodButtonUnselectedClass = isDarkMode ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' : 'bg-gray-200 text-gray-800 hover:bg-gray-300';
  const formBgClass = isDarkMode ? 'bg-gray-700' : 'bg-gray-100';
  const inputClass = isDarkMode ? 'bg-gray-800 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-800';
  const greenButtonClass = 'bg-green-600 text-white hover:bg-green-700';
  const backButtonClass = isDarkMode ? 'bg-gray-600 text-white hover:bg-gray-500' : 'bg-gray-400 text-white hover:bg-gray-500';

  return (
    <main className={`flex-1 p-6 rounded-2xl shadow-xl m-4 ${mainBgClass} transition-colors duration-300`}>
      <h2 className="mb-8 text-4xl font-bold text-center">Confirmar Pago</h2>
      <div className={`max-w-md mx-auto p-8 rounded-2xl shadow-lg text-center ${cardBgClass} transition-colors duration-300`}>
        <h3 className={`text-3xl font-bold mb-4 ${titleColorClass}`}>
          Plan: {planDetails.name}
        </h3>
        <p className={`text-5xl font-extrabold mb-6 ${priceColorClass}`}>
          US${planDetails.price}
        </p>
        <p className={`text-lg mb-8 ${textColorClass}`}>
          Estás a punto de suscribirte al plan {planDetails.name}.
          Selecciona tu método de pago.
        </p>

        {paymentError && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4 text-sm" role="alert">
            <strong className="font-bold">¡Error!</strong>
            <span className="block sm:inline"> {paymentError}</span>
          </div>
        )}
       
        <div className="flex justify-center mb-6 space-x-4">
           

        </div>

        {selectedMethod === 'paypal' && (
          <div className="w-full">
            <PayPalButton
              amount={planDetails.price}
              description={`Suscripción al plan ${planDetails.name}`}
              onSuccess={handlePayPalSuccess}
              onError={handlePayPalError}
            />
          </div>
        )}

        {selectedMethod === 'card' && (
          <div className={`p-5 rounded-xl ${formBgClass} transition-colors duration-300`}>
            <p className={`text-lg mb-4 ${textColorClass}`}>
              Aquí iría el formulario de pago con tarjeta (ej. Stripe Elements).
            </p>
            <div className="space-y-3">
              <input type="text" placeholder="Número de Tarjeta" className={`w-full p-3 rounded-lg border ${inputClass} focus:outline-none focus:ring-2 focus:ring-blue-500`} />
              <div className="flex space-x-3">
                <input type="text" placeholder="MM/AA" className={`w-1/2 p-3 rounded-lg border ${inputClass} focus:outline-none focus:ring-2 focus:ring-blue-500`} />
                <input type="text" placeholder="CVC" className={`w-1/2 p-3 rounded-lg border ${inputClass} focus:outline-none focus:ring-2 focus:ring-blue-500`} />
              </div>
              <button className={`w-full mt-4 py-3 rounded-xl font-semibold transition-colors duration-200 ${greenButtonClass} shadow-md hover:shadow-lg`}>
                Pagar con Tarjeta
              </button>
            </div>
          </div>
        )}

        {selectedMethod === 'bank' && (
          <div className={`p-5 rounded-xl ${formBgClass} transition-colors duration-300`}>
            <p className={`text-lg mb-4 ${textColorClass}`}>
              Realiza un depósito bancario a la siguiente cuenta:
            </p>
            <div className="mt-4 text-left space-y-1">
              <p className={`font-semibold ${titleColorClass}`}>Banco: Banco Holmio</p>
              <p className={`font-semibold ${titleColorClass}`}>Número de Cuenta: 1234567890</p>
              <p className={`font-semibold ${titleColorClass}`}>CLABE: 000111222333444555</p>
              <p className={`font-semibold ${titleColorClass}`}>Beneficiario: Holmio S.A. de C.V.</p>
              <p className={`mt-4 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Una vez realizado el depósito, por favor envía el comprobante a pagos@holmio.net para activar tu plan.
              </p>
            </div>
            <button className={`w-full mt-4 py-3 rounded-xl font-semibold transition-colors duration-200 ${greenButtonClass} shadow-md hover:shadow-lg`}>
              Ya Realicé el Depósito
            </button>
          </div>
        )}

        <button
          onClick={onBack}
          className={`w-full mt-6 py-3 rounded-xl text-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${backButtonClass}`}
        >
          Volver a Planes
        </button>
      </div>
    </main>
  );
};

export default PaymentPage;

// DONE